const imagePreview = {
    types: {
        LARGE: {
            borderRadius: 16,
            maxWidth: '14.875rem',
            maxHeight: '9.875rem',
        },
        MEDIUM: {
            borderRadius: 8,
            maxWidth: '3.5rem',
            maxHeight: '3.5rem',
        },
        SMALL: {
            borderRadius: 4,
            maxWidth: '1.25rem',
            maxHeight: '1.25rem',
        },
    },
};
export default imagePreview;
//# sourceMappingURL=imagePreview.js.map